import React from 'react';
import { PERMISSIONS } from 'pages/InternalDebt/utils/permission';

const InternalDebtPage = React.lazy(() => import('pages/InternalDebt/InternalDebtPage'));

const internalDebtRoutes = [
  { path: '/internal-debt', exact: true, name: 'Công nợ nội bộ', function: PERMISSIONS.VIEW, component: InternalDebtPage },
  { path: '/internal-debt/detail', exact: true, name: 'Chi tiết công nợ nội bộ', function: PERMISSIONS.VIEW, component: InternalDebtPage },
];

export default internalDebtRoutes;
